import axios from '../axios-auth'
import orginal_axios from "axios";

export const stockReturnReportService = {
    getStockReturnReportList,
    getAllStockReturnReportList,
    getStockReturnSummary,
    exportStockReturnExcel
}

function getStockReturnReportList(searchParams, page, size, sortedBy) {
    let url = '';
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    if (sortedBy == 'null,asc') {
        url = '/auth/stock-return-report?page=' + page + '&size=' + size;
    } else {
        url = '/auth/stock-return-report?page=' + page + '&size=' + size + '&sort=' + sortedBy;
    }

    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.productName) {
        url += '&productName=' + searchParams.productName;
    }
    if (searchParams.productCode) {
        url += '&productCode=' + searchParams.productCode;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }    
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.saleType) {
        url += '&saleType=' + searchParams.saleType;
    }
    return axios.get(url);
}


function getAllStockReturnReportList(searchParams) {
    let url = '';
    url = '/auth/stock-return-report?'
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.productName) {
        url += '&productName=' + searchParams.productName;
    }
    if (searchParams.productCode) {
        url += '&productCode=' + searchParams.productCode;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }    
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.saleType) {
        url += '&saleType=' + searchParams.saleType;
    }
    return axios.get(url);
}

function getStockReturnSummary(searchParams) {
    let url = '';
    url = '/auth/stock-return-summary-report?'
    if (searchParams.fromDate) {
        url += '&fromDate=' + searchParams.fromDate;
    }
    if (searchParams.toDate) {
        url += '&toDate=' + searchParams.toDate;
    }
    if (searchParams.shopId) {
        url += '&shopId=' + searchParams.shopId;
    }
    if (searchParams.productName) {
        url += '&productName=' + searchParams.productName;
    }
    if (searchParams.productCode) {
        url += '&productCode=' + searchParams.productCode;
    }
    if (searchParams.saleNo) {
        url += '&saleNo=' + searchParams.saleNo;
    }    
    if (searchParams.payType) {
        url += '&payType=' + searchParams.payType;
    }
    if (searchParams.saleType) {
        url += '&saleType=' + searchParams.saleType;
    }
    return axios.get(url);
}

function exportStockReturnExcel(searchParams) {
    let params = {
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.brandId) {
        params["brandId"] = searchParams.brandId;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.saleNo) {
        params["saleNo"] = searchParams.saleNo;
    }
    if (searchParams.payType) {
        params["payType"] = searchParams.payType;
    }
    if (searchParams.saleType) {
        params["saleType"] = searchParams.saleType;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stock-return-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}